module.exports = __webpack_public_path__ + "static/doctor-profile-d0188b8157a684bb09e1ecadf4880e6e.jpg";